export const DocumentService = Object.freeze({
	Google: 'gdrive',
	Office: 'office365',
	Dropbox: 'dropbox',
	Onedrive: 'onedrive',
	OnlyOffice: 'onlyoffice',
	Local: 'l',
});

export const DocumentType = Object.freeze({
	Docx: 'docx',
	Xlsx: 'xlsx',
	Pptx: 'pptx',
	Board: 'board',
});
